<template>
  <v-snackbar
    app
    v-model="snackbar.visible" 
    :color="snackbar.color"
    :right="right"
    :bottom="bottom"
    :timeout="timeout"
    :multi-line="multiline"
    @input="onVisibilityChange"
  >
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn 
        icon 
        v-bind="attrs" 
        @click="closeSnackbar"
      ><v-icon>mdi-close</v-icon></v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      timeout: 4000,
      multiline: false,
      right: true,
      bottom: true,
    }
  },
  computed: {
    snackbar() {
      return this.$store.getters.snackbar
    }
  },
  methods: {
    closeSnackbar() {
      this.$store.commit('closeSnackbar')
    },
    onVisibilityChange(visible) {
      // When snackbar becomes hidden (either by timeout or manual close)
      if (!visible) {
        this.$store.commit('closeSnackbar')
      }
    }
  },
  mounted() {
    // Reset snackbar state on app load to prevent persisted messages from showing
    if (this.snackbar.visible) {
      this.$store.commit('closeSnackbar')
    }
  }
}
</script>